import { BannerRep } from "@/api/home";
import { server } from "@/utils/client";
type SwitchType = 1 | 2; // 1开启 2关闭

export interface ConfigType {
    show_free_game: SwitchType;
    show_again_game: SwitchType;
    identity_verify: IdentityVerify;
}
export interface IdentityVerify {
    /**
     * 充值实名，1开启 2关闭
     */
    deposit: SwitchType;
    /**
     * 注册实名，1开启 2关闭
     */
    register: SwitchType;
    /**
     * 提现实名，1开启 2关闭
     */
    withdraw: SwitchType;
}
export const getConfigApi = async () => {
    return server
        .request<ConfigType>({
            url: "/v1/api/front/system/configs",
            method: "POST",
        })
        .then((res) => {
            return res.data;
        });
};

export const getShareApi = async (params: { channel_url: string }) => {
    return server.request({
        url: `/v1/api/user/channel/add_click`,
        method: "get",
        params,
    });
};
/**
 * @description
 * 获取邮箱联系列表
 *   POST /v1/api/front/links/contacts
 *   接口ID：257797888
 *   接口地址：https://app.apifox.com/link/project/4790544/apis/api-257797888
 */
export interface ContactType {
    /**
     * 邮箱地址
     */
    email: string;
    /**
     * 名称
     */
    name: string;
    /**
     * 侧边栏显示，1显示 2不显示
     */
    show_bar: SwitchType;
    /**
     * 首页显示，1显示 2不显示
     */
    show_home: SwitchType;
}

export const getContactsApi = async () => {
    return server.request<ContactType[]>({
        url: `/v1/api/front/links/contacts`,
        method: "POST",
    });
};

/**
 * @description
 * 获取侧边栏
 *   POST /v1/api/front/sidebar
 *   接口ID：258235334
 *   接口地址：https://app.apifox.com/link/project/4790544/apis/api-258235334
 */

export const getSidebarActivitiesApi = async () => {
    return server.request<BannerRep[]>({
        url: `/v1/api/front/sidebar`,
        method: "POST",
    });
};
/**
 * 获取分享和推广的URl
 *   POST /v1/api/front/system/configs_url
 *   接口ID：267745030
 *   接口地址：https://app.apifox.com/link/project/4790544/apis/api-267745030
 */

export interface LinksType {
    /**
     * 备注
     */
    comment: string;
    /**
     * 创建时间
     */
    create_at: string;
    /**
     * 主键 ID
     */
    id: string;
    /**
     * 租户 ID
     */
    renter_id: string;
    /**
     * 状态 1:开始 2：关闭
     */
    status: string;
    /**
     * 类型 1:分享 2：代理 ：3：推广
     */
    type: 1 | 2 | 3;
    /**
     * 更新时间
     */
    update_at: string;
    /**
     * URL
     */
    url: string;
}
export const getShareLinkApi = () => {
    return server.post<LinksType[]>({
        url: "/v1/api/front/system/configs_url",
    });
};
